import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import {toast} from "react-toastify";
import {Link, useParams} from "react-router-dom";
import AdminPrinterCashier from "./AdminPrinterCashier";
import AdminCashierAPI from "../../../apis/adminApi/AdminCashierAPI";
import Pagination from "../../assets/Pagination";
import TableLoader from "../../loaders/TableLoader";


const AdminRapportCashOutUSD = () => {

    let {city} = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    const [accounts, setAccounts] = useState([]);
    const [cashOutsUSD, setCashOutsUSD] = useState([]);
    const [cashOutsUSDNoFiltered, setCashOutsUSDNoFiltered] = useState([]);
    const [startAt, setStartAt] = useState("");
    const [endAt, setEndAt] = useState("");
    const [sources, setSources] = useState([]);


    const fetchRapportCashOutsUSD = async () => {
        try{
            const data =  await AdminCashierAPI.findRapportCashOutsUSD();
            setCashOutsUSD(data);
            setCashOutsUSDNoFiltered(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement du rapport des sorties caisse USD  !");
        }
    };

    const getCashAccounts = async () => {
        try{
            const data =  await AdminCashierAPI.getCashAccounts();
            setAccounts(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes !");
        }
    };

    const getCashSources = async () => {
        try{
            const data =  await AdminCashierAPI.findCashAccounts();
            setSources(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des comptes sources !");
        }
    };

    const [param, setSetting] = useState();

    //Au chargement du composant on va chercher les buses
    useEffect(() => {
        fetchRapportCashOutsUSD();
        getCashAccounts();
        getCashSources();
        return () => console.log("...");
    },[]);

    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 500;

    const filteredCashOutsUSD = cashOutsUSD.filter(
        t =>
            t.beneficiary.toLowerCase().includes(search.toLowerCase()) ||
            t.motif.toLowerCase().includes(search.toLowerCase()) ||
            t.account.toLowerCase().includes(search.toLowerCase()) ||
            t.source.toLowerCase().includes(search.toLowerCase()) ||
            t.currency.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedCashOutsUSD = Pagination.getData(
        filteredCashOutsUSD,
        currentPage,
        itemsPerPage
    );

    let counter = 1;

    const handleStartedDate = ({currentTarget}) => {
        setStartAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleEndedDate = ({currentTarget}) => {
        setEndAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleBtns = () => {

        if(startAt !== "" && endAt === "") {
            const filtered = cashOutsUSD.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") === Moment(startAt).format("YYYY/MM/DD"));
            setCashOutsUSD(filtered);
        } else if (startAt !== "" && endAt !== "") {
            const filtered = cashOutsUSD.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD")
                    && Moment(item.created_at).format("YYYY/MM/DD") <= Moment(endAt).format("YYYY/MM/DD"));
            setCashOutsUSD(filtered);
        }else{
            const filtered = cashOutsUSD.filter(item=>
                Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD"));
            setCashOutsUSD(filtered)
        }

    };

    function calculTotalAllCurrency(data) {
        let totalUSD = 0;
        let totalCDF = 0;
        data.map((d) =>  {
            if (d.currency === "FC"){
                totalCDF += d.amount;
            }else{
                totalUSD += d.amount;
            }
        });
        return {totalUSD, totalCDF}
    }


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <h2 className="fw-bold p-2">Rapport de sortie caisse USD</h2>
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <h2 className="card-title">
                                        Total : <b className="text-primary">{cashOutsUSDNoFiltered.length} </b>
                                    </h2>
                                </div>
                                <div className="col">
                                    <h2 className="card-title">
                                        Total avec filtre : <b className="text-success">{paginatedCashOutsUSD ? paginatedCashOutsUSD.length : 0} </b>
                                    </h2>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Recherche par compte
                                        </label>
                                        <select
                                            className="form-control"
                                            //size={(buses.length)}
                                            name="account"
                                            value={search}
                                            onChange={handleSearch}
                                        >

                                            <option value="">Choisir...</option>
                                            <option value="">TOUA LES COMPTES</option>
                                            {accounts && accounts.map((account) => (
                                                <option key={account.id} value={account.compte}>
                                                    {account.compte}</option>
                                            ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group mt-3">
                                        <label htmlFor="source" className="text-dark">Recherche par source</label>
                                        <select
                                            className="form-control mb-2"
                                            //size={(buses.length)}
                                            name="source"
                                            id="source"
                                            value={search}
                                            onChange={handleSearch}
                                        >

                                            <option value="">Choisir..</option>
                                            <option value="">TOUTES LES SOURCES</option>
                                            {sources && sources.map((account) => (
                                                <option key={account.id} value={account.name}>
                                                    {account.name}</option>
                                            ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Date debut
                                        </label>
                                        <input type="date" onChange={handleStartedDate} value={startAt}
                                               name="startDate" id="startDate" autoComplete="off" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <label htmlFor="endDate" className="text-dark">
                                            Date fin
                                        </label>
                                        <input type="date" onChange={handleEndedDate} value={endAt}
                                               name="endDate" id="endDate" autoComplete="off" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div className="form-group mt-3">
                                        <button onClick={handleBtns} className="mt-4 btn btn-primary">Filtrer</button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 justify-content-end">
                                    <div className="form-group d-flex float-end">
                                        <AdminPrinterCashier param={param} type={"out"} devise={"USD"} endAt={endAt} startAt={startAt} critere={search} data={filteredCashOutsUSD} />
                                    </div>
                                </div>
                            </div>

                            <hr/>
                            <table className="table table-hover table-striped table-responsive">
                                <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" colSpan="4">Compte</th>
                                    <th scope="col">Source</th>
                                    <th scope="col">Bénéficiaire</th>
                                    <th scope="col">Motif</th>
                                    <th scope="col">Montant</th>
                                    <th scope="col">Devise</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Options</th>
                                </tr>
                                </thead>
                                {!loading &&<tbody>
                                {paginatedCashOutsUSD.map((cashOut) => (
                                    <tr key={cashOut.id}>
                                        <td>{counter++}</td>
                                        <td colSpan="4"><b className="text-primary">{cashOut.account}</b></td>
                                        <td>{cashOut.source}</td>
                                        <td>{cashOut.beneficiary}</td>
                                        <td>{cashOut.motif}</td>
                                        <td><b>{cashOut.amount}</b></td>
                                        <td>{cashOut.currency}</td>
                                        <td>{Moment(cashOut.created_at).format("DD/MM/YYYY")}</td>
                                        <td>
                                            <Link className="btn btn-sm btn-outline-primary mx-1" to={`/admin/cashier/cashOut/edit/${cashOut.id}`}>
                                                <i className="bi bi-pen-fill"></i>
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                                }

                                </tbody>}
                            </table>
                            {loading && <TableLoader width={300} height={350} />}

                            <div className="invoice-price">
                                <div className="invoice-price-left">
                                    <div className="invoice-price-row">
                                        <div className="sub-price">
                                            {/*<small>SUBTOTAL</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                        <div className="sub-price">
                                            <i className="fa fa-plus text-muted"></i>
                                        </div>
                                        <div className="sub-price">
                                            {/*<small>TAX (5.4%)</small>*/}
                                            <span className="text-inverse"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-price-right">
                                    <small>TOTAL</small>
                                    <span className="f-w-600"> {filteredCashOutsUSD && calculTotalAllCurrency(filteredCashOutsUSD).totalUSD > 0 && calculTotalAllCurrency(filteredCashOutsUSD).totalUSD} $</span>
                                </div>
                            </div>
                            <br/>

                            {itemsPerPage < filteredCashOutsUSD.length &&
                                <Pagination
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    length={filteredCashOutsUSD.length}
                                    onPageChange={handleChangeCurrentPage}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminRapportCashOutUSD;
